import { makeVar } from "@apollo/client";
import { datadogRum } from "@datadog/browser-rum";

type Args = {
  startTime: number;
};

export const touchDeviceMiniDisplayedStartTimeVar = makeVar<number>(0);

export const touchDeviceMiniDisplayedTime = (args: Args) => {
  const { startTime } = args;
  const touchDeviceMiniDisplayedEndTime = new Date().getTime();
  const touchDeviceMiniDisplayedTime = touchDeviceMiniDisplayedEndTime - startTime;
  datadogRum.addAction("touchDeviceMiniDisplayedTime", { displayTime: touchDeviceMiniDisplayedTime });
};
